import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import { Typography, CircularProgress, Grid, Paper } from '@material-ui/core';
import { useLocation, useHistory } from 'react-router-dom';

import Auth from '../utils/Auth';
import CorrectionShower from '../explorer/CorrectionShower';
import Style from "../utils/Style";
import ExplorerNavigationBar from '../explorer/ExplorerNavigationBar';

export default function Correction() {
  const [correction, setCorrection] = useState(null);
  const [request, setRequest] = useState({ source: null, error: null });
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const history = useHistory();
  const projectId = location.pathname.split('/')[2];
  const correctionId = location.pathname.split('/')[4];
  const userId = Auth.getUserID();
  const style = Style();
  const projectName = location.state?.projectName;

  useEffect(() => {
    getCorrection(correctionId);
  }, [correctionId]);

  const getCorrection = async id => {
    let url = `${process.env.REACT_APP_BASE_URL}/users/${userId}/projects/${projectId}/corrections/${id}`;
    const source = Axios.CancelToken.source();

    setLoading(true);

    try {
      const response = await Axios.get(url, { cancelToken: source.token });
      const errorsResponse = await Axios.get(`${url}/errors`, { cancelToken: source.token });

      const combinedCorrection = {
        ...response.data,
        errors: errorsResponse.data
      };

      setCorrection(combinedCorrection);
      setRequest({ source: null, error: null });
    } catch (error) {
      if (Axios.isCancel(error)) {
        setRequest({ source: null, error: null });
      } else {
        setRequest({ source: null, error: error });
      }
    } finally {
      setLoading(false);
    }

    setRequest({ source: source, error: null });
  };

  if (loading) return <CircularProgress style={{ margin: 'auto' }} />;

  if (request.error) return <Typography color="error">Error loading correction</Typography>;

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper className={style.paper}>
            <ExplorerNavigationBar
              style={style}
              data={{ init: "Proyectos", project: {id : projectId, name: projectName ?? `Proyecto ${projectId}`}, correction: correction }}
              actions={{
                selectInit: () => history.push('/projects'),
                selectProject: () => history.push(`/projects/${projectId}`),
                selectCorrection: () => {}
              }}
            />
          </Paper>
        </Grid>
      </Grid>
      <CorrectionShower style={style} correction={correction} />
    </div>
  );
}